import axios from 'axios';
// import { useStorage } from "vue3-storage";
import CurrentUserService from '../service/CurrentUserService';
import { RFP_CONTRIBUTOR_ROLE_KEY } from '../utilities/constants';
import { getApi } from './common/apis';
const currentUser = new CurrentUserService();

function getAxios() {
    currentUser.refreshCognitoJwt();
    let jwt = currentUser.jwt;

    //let jwt = storage.getStorageSync("jwt");

    const instance = axios.create({
        baseURL: process.env.VUE_APP_DOT_NET_BASE_URL,
        withCredentials: false,
    });

    // set common headers
    instance.defaults.headers.common['Authorization'] = jwt;
    instance.defaults.headers.common['Content-Type'] = 'application/json';

    return instance;
}

async function getUserMenuData(cognitoUsername) {
    var result = await getAxios()
        .get(`/Users/${cognitoUsername}/menuData`)
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.error(err.stack);
        });

    return result;
}

//const ACCOUNT_TYPE_UNKNOWN = -1;
const ACCOUNT_TYPE_ARENACX = 0;
const ACCOUNT_TYPE_MEMBER = 1;
const ACCOUNT_TYPE_PARTNER = 2;
const ACCOUNT_TYPE_CHANNEL = 3;
const ACCOUNT_TYPE_CONTRIBUTOR = 2
const DASHBOARD_STATUS_RETIRED = 1;
const DASHBOARD_STATUS_WIP = 2; //  work-in-progress

// ArenaCX
const DEFAULT_CHANNEL_SUBNETWORK_ID = "f4cd7264-3f00-463b-b2e9-d9e69c3ec193";

const origin = process.env.VUE_APP_PLATFORM_ID


// Add channel admin menu items
function getChannelAdminMenuItems() {
    return {
        label: 'Channel Summary',
        items: [
            new MenuItem('Channel Profile', 'pi-user', undefined, '/channel/profile', currentUser.marketplaceUser.accountId, currentUser.marketplaceUser.subnetworkId),
            new MenuItem('Home', 'pi-home', undefined, '/channel/home', currentUser.marketplaceUser.accountId, currentUser.marketplaceUser.subnetworkId),
            new MenuItem('Vendor Selection', 'pi-user', undefined, '/channel/vendor-selection', currentUser.marketplaceUser.accountId, currentUser.marketplaceUser.subnetworkId),
        ],
    };
}

// Add RFP Contributor menu items - only shows Opportunities
function getRfpContributorMenuItems() {
    return {
        label: 'RFP Contributor',
        items: [
            new MenuItem('Opportunities', 'pi-thumbs-up', undefined, '/partner/opportunities', currentUser.marketplaceUser.accountId),
        ],
    };
}

export default class SidebarMenuService {
    async getMenuData(cognitoUsername) {
        let userMenuData = await getUserMenuData(cognitoUsername);

        //starting to loop thru accounts

        var allAccountItems = [];

        // If this is an ArenaCX user, show all the links for all members and partners, grouped.
        // If not, just show that one user their own single Member's/Partner's links.
        if (currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX) {
            let channelAccountData = userMenuData.accessToAccounts.filter((acct) => acct.accountTypeId == ACCOUNT_TYPE_CHANNEL && acct.subnetworkId !== null);
            console.log("Channel Account Data", channelAccountData);
            
            // Mark default channels based on subnetwork ID
            channelAccountData.find(channel => {
                if (channel.subnetworkId === DEFAULT_CHANNEL_SUBNETWORK_ID) {
                    channel.isDefaultChannel = true;
                    channel.name = `Default Channel`;
                } else {
                    channel.isDefaultChannel = false;
                }
            });
            
            // Sort channels to put default channels at the top
            channelAccountData.sort((a, b) => {
                if (a.isDefaultChannel && !b.isDefaultChannel) return -1;
                if (!a.isDefaultChannel && b.isDefaultChannel) return 1;
                return a.name.localeCompare(b.name); // Alphabetical order for channels with same default status
            });
            
            let channelAccountItems = getAccountItems(channelAccountData, ACCOUNT_TYPE_CHANNEL);
            let acxChannelItems = {};
            acxChannelItems.label = 'Channel Partners';
            acxChannelItems.icon = 'pi pi-fw pi-globe';
            acxChannelItems.items = channelAccountItems;
            allAccountItems.push(acxChannelItems);
           
            var memberAccountData = userMenuData.accessToAccounts.filter((acct) => acct.accountTypeId == ACCOUNT_TYPE_MEMBER);
            var memberAccountItems = getAccountItems(memberAccountData, ACCOUNT_TYPE_MEMBER);
            var acxMemberItems = {};
            acxMemberItems.label = 'Customers';
            acxMemberItems.icon = 'pi pi-fw pi-globe';
            acxMemberItems.items = memberAccountItems;
            allAccountItems.push(acxMemberItems);

            let partnerAgreements = {};
            if (process.env.VUE_APP_PLATFORM_NAME !== 'ArenaCX') {
                let agreementsResponse = await getApi('v1/vendor-agreements/status');
                partnerAgreements = agreementsResponse && agreementsResponse.data ? agreementsResponse.data.partner_agreements : {};
            }

            let partnerAccountData = userMenuData.accessToAccounts.filter((acct) => acct.accountTypeId == ACCOUNT_TYPE_PARTNER);
            let partnerAccountItems = getAccountItems(partnerAccountData, ACCOUNT_TYPE_PARTNER, partnerAgreements);
            let acxPartnerItems = {};
            acxPartnerItems.label = 'Vendor Partners';
            acxPartnerItems.icon = 'pi pi-fw pi-globe';
            acxPartnerItems.items = partnerAccountItems;
            allAccountItems.push(acxPartnerItems);


             // Add Reporting menu for super admin
             let reportingItems = [];
             let partnerVendorDownloadLink = new MenuItem('Vendor Partner Download', 'pi-download', undefined, '/reporting/partner-vendor-download');
             let partnerVendorRankingLink = new MenuItem('Vendor Partner Ranking', 'pi-chart-line', undefined, '/reporting/partner-vendor-ranking');
             let outdatedVendorEmailsLink = new MenuItem('Outdated Vendor Partner Emails', 'pi-exclamation-triangle', undefined, '/reporting/outdated-vendor-emails');
             let outdatedAdminEmailsLink = new MenuItem('Outdated Admin Emails', 'pi-flag', undefined, '/reporting/outdated-admin-emails');
             reportingItems.push(partnerVendorDownloadLink);
             reportingItems.push(partnerVendorRankingLink);
             reportingItems.push(outdatedVendorEmailsLink);
             reportingItems.push(outdatedAdminEmailsLink);
             
             let reportingMenu = {
                 label: 'Reporting',
                 icon: 'pi pi-fw pi-chart-bar',
                 items: reportingItems
             };
             allAccountItems.push(reportingMenu);

           
        } else if (currentUser.userAccountTypeId == ACCOUNT_TYPE_CHANNEL) {
            allAccountItems.push(getChannelAdminMenuItems());

            let partnerAgreements = {};
            if (process.env.VUE_APP_PLATFORM_NAME !== 'ArenaCX') {
                let agreementsResponse = await getApi('v1/vendor-agreements/status');
                partnerAgreements = agreementsResponse && agreementsResponse.data ? agreementsResponse.data.partner_agreements : {};
            }

            let partnerAccountData = userMenuData.accessToAccounts.filter((acct) => acct.accountTypeId == ACCOUNT_TYPE_PARTNER);
            let partnerAccountItems = getAccountItems(partnerAccountData, ACCOUNT_TYPE_PARTNER, partnerAgreements);
            let acxPartnerItems = {};
            acxPartnerItems.label = 'Vendor Partners';
            acxPartnerItems.icon = 'pi pi-fw pi-globe';
            acxPartnerItems.items = partnerAccountItems;
            allAccountItems.push(acxPartnerItems);
        } else if (currentUser.userAccountTypeId == ACCOUNT_TYPE_PARTNER && currentUser.marketplaceUser.userRole.roleKey === RFP_CONTRIBUTOR_ROLE_KEY
        ) {
            // RFP Contributors only see the Opportunities page
            allAccountItems.push(getRfpContributorMenuItems());
        } else {
            //var accountTypeRouterPath = userMenuData.userRole.roleKey.split(':')[0];  // e.g., "partner" from roleKey="partner:business:user"
            var userAccountItems = getAccountItems(userMenuData.accessToAccounts, currentUser.userAccountTypeId);
            var userItems = {};
            // userItems.label = 'Your Marketplace Tools';
            userItems.icon = 'pi pi-fw pi-globe';
            userItems.items = userAccountItems;
            allAccountItems.push(userItems);
        }

        return allAccountItems;
    }
}

function getAccountItems(accountData, userAccountType, partnerAgreements = {}) {
    var accountItems = [];

    var accountTypeRouterPath = '';
    switch (userAccountType) {
        case ACCOUNT_TYPE_PARTNER:
            accountTypeRouterPath = 'partner';
            break;

        case ACCOUNT_TYPE_MEMBER:
            accountTypeRouterPath = 'member';
            break;
        
        case ACCOUNT_TYPE_CHANNEL:
            accountTypeRouterPath = 'channel';
            break;

        case ACCOUNT_TYPE_CONTRIBUTOR:
            accountTypeRouterPath = 'partner'; // RFP Contributors use partner routes
            break;

        default:
            accountTypeRouterPath = '';
            break;
    }

    accountData.forEach((account) => {
        var parentAccountId = account.accountId;

        var arenaItems = [];

          // Add Channel Profile link for Channel accounts when user is ArenaCX admin
          if (currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX && account.accountTypeId == ACCOUNT_TYPE_CHANNEL) {
            var channelProfileLink = new MenuItem('Channel Profile', 'pi-user', undefined, '/channel/profile', account.accountId, account.subnetworkId);
            arenaItems.push(channelProfileLink);
        }

        // Add link to their landing page
        var homeLink = new MenuItem('Home', 'pi-home', undefined, `/${accountTypeRouterPath}/home`, parentAccountId, account.subnetworkId);
        arenaItems.push(homeLink);

          // Add Vendor Selection link for Channel accounts when user is ArenaCX admin
          if (currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX && account.accountTypeId == ACCOUNT_TYPE_CHANNEL) {
            var vendorSelectionLink = new MenuItem('Vendor Selection', 'pi-user', undefined, '/channel/vendor-selection', account.accountId, account.subnetworkId);
            arenaItems.push(vendorSelectionLink);
        }

        

        var uniqueDashboardGroupNames = [...new Set(account.accountDashboards.map((db) => db.groupName))].sort((a, b) => a > b);

        uniqueDashboardGroupNames.forEach((dgn) => {
            var acctDashboards = account.accountDashboards
                .filter((ad) => ad.groupName == dgn)
                .sort((a, b) => a.displayOrdinal > b.displayOrdinal);
            var dashboardItems = [];

            acctDashboards.forEach((acctDash) => {
                if (acctDash.dashboard.status !== DASHBOARD_STATUS_RETIRED) {
                    acctDash.dashboard.accountId = parentAccountId;
                    var iconClass = acctDash.dashboard.status == DASHBOARD_STATUS_WIP ? 'pi-cog' : 'pi-chart-line';
                    var embedData = JSON.parse(acctDash.dashboard.embedData);
                    var dashItem = new MenuItem(
                        acctDash.dashboard.name,
                        iconClass,
                        undefined,
                        `/favorites/domodashboardview/1/${embedData.details.embed_code}`
                    );
                    dashboardItems.push(dashItem);
                }
            });

            if (dashboardItems.length > 0) {
                var arenaItem = new MenuItem(dgn, 'pi-star', dashboardItems, undefined);
                arenaItems.push(arenaItem);
            }
        });

        if (account.accountTypeId == ACCOUNT_TYPE_PARTNER) {
            var partnerProfileLink = new MenuItem('Profile', 'pi-user', undefined, `/partner/profile`, account.accountId);
            arenaItems.push(partnerProfileLink);

            var answerBankLink = new MenuItem('Answer Bank', 'pi-file', undefined, `/partner/answerbank`, account.accountId);
            arenaItems.push(answerBankLink);

            var marketingProfileLink = new MenuItem(
                'Marketing Profile',
                'pi-file',
                undefined,
                `/partner/marketing`,
                account.accountId
            );
            arenaItems.push(marketingProfileLink);
        }

        // contents will be passed as an array after the dashboard contents are received instead of undefined
        // dummy code for now
        // var dashboardsLink = new MenuItem('Dashboards', 'pi-star', undefined, `/account/${account.accountId}/dashboarddemo`);
        // arenaItems.push(dashboardsLink);

        // var libraryLink = new MenuItem('Document Library', 'pi-book', undefined, `/account/${account.accountId}/documents`);
        // arenaItems.push(libraryLink);

        // Special case -- just ARENACX users can see these links until their functionality is complete
        if (currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX || currentUser.userAccountTypeId == ACCOUNT_TYPE_CHANNEL) {
            // Add Library and Opportunities links
            if (account.accountTypeId == ACCOUNT_TYPE_PARTNER) {
                // Always show opportunities and users for all vendors
                // Backend will filter opportunities based on vendor agreements with channels
                
                var showOppsAndUsers = true;
                if (process.env.VUE_APP_PLATFORM_NAME !== 'ArenaCX') {
                    showOppsAndUsers = partnerAgreements[account.accountId] === true;
                } else {
                    // Original behavior for ArenaCX: only Site Admins see these for partners
                    showOppsAndUsers = currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX;
                }
                
                var oppsLink = new MenuItem(
                    'Opportunities',
                    'pi-thumbs-up',
                    undefined,
                    `/partner/opportunities`,
                    account.accountId
                );
                oppsLink.visible = showOppsAndUsers;
                arenaItems.push(oppsLink);

                var Userslink = new MenuItem('Users', 'pi-users', undefined, `/partner/users`, account.accountId);
                Userslink.visible = showOppsAndUsers;
                arenaItems.push(Userslink);
            }

            // var libraryLink = new MenuItem('Document Library', 'pi-book', undefined, `/account/documents`, account.accountId);
            // arenaItems.push(libraryLink);
        } else if (currentUser.userAccountTypeId === ACCOUNT_TYPE_PARTNER) {
            var partnerOpportunitiesLink = new MenuItem('Opportunities', 'pi-thumbs-up', undefined, `/partner/opportunities`, account.accountId);
            arenaItems.push(partnerOpportunitiesLink);
        }

        // Add Invoice/Billing links
        if (account.integrationDetails != null) {
            var routeEnd = 'invoices';
            switch (account.accountTypeId) {
                case ACCOUNT_TYPE_MEMBER:
                    routeEnd = 'invoices';
                    break;
                case ACCOUNT_TYPE_PARTNER:
                    routeEnd = 'billing';
                    break;
                default:
                    routeEnd = 'invoices';
                    break;
            }

            var invoiceLink = new MenuItem('Billing', 'pi-money-bill', undefined, `/account/${routeEnd}`, account.accountId);
            arenaItems.push(invoiceLink);
        }
        //add this collection of arena links
        if (process.env.VUE_APP_ENV != 'PRODUCTION') {
            if (
                currentUser.userAccountTypeId != ACCOUNT_TYPE_ARENACX &&
                account.accountTypeId == ACCOUNT_TYPE_MEMBER &&
                account.users[0].userRole.roleKey === 'member:business:admin'
            ) {
                var partnerSelector = new MenuItem(
                    'Partner Selector',
                    'pi-question-circle',
                    undefined,
                    `/member/partnerselector`,
                    account.accountId
                );
                arenaItems.push(partnerSelector);
            }
        }

        if (
            arenaItems.length > 0 &&
            (currentUser.userAccountTypeId == ACCOUNT_TYPE_ARENACX || currentUser.userAccountTypeId == ACCOUNT_TYPE_CHANNEL)
        ) {
            var arenaItem = new MenuItem(account.name, 'pi-globe', arenaItems, undefined);
            accountItems.push(arenaItem);
        } else {
            accountItems = arenaItems;
        }
    });

    return accountItems;
}

class MenuItem {
    constructor(label, icon, children, to, id, subnetworkId) {
        this.label = label;
        this.icon = 'pi pi-fw ' + icon;

        if (id !== undefined) {
            this.accountId = id;
        }

        if (subnetworkId !== undefined) {
            this.subnetworkId = subnetworkId;
        }

        this.visible = true;

        // These either have child items, or are actual links to a router location
        if (children !== undefined) {
            this.items = [...children];
        }
        if (to !== undefined) {
            this.to = to;
        }
    }
}
